<script>
    import {slugify} from "../lib/lib";
    import CategoryAutoComplete from "./CategoryAutoComplete.svelte";
    import {categorySave} from "../lib/requests";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';

    export let parent_id = 0;
    export let closeCallback;

    let category = {
        id: 0,
        parent_id: parent_id,
        alias_parent_id: 0,
        name_el: '',
        name_en: '',
        slug: '',
        is_visible: 1,
        children: [],
    }

    const onNameFocusOut = event => {
        category.name_el = category.name_el.trim();
        category.name_en = category.name_en != null ? category.name_en.trim() : '';

        if (category.slug.trim().length == 0) {
            if (category.name_en) {
                category.slug = slugify(category.name_en);
            } else {
                category.slug = slugify(category.name_el);
            }
        }
    }

    const onSave = async () => {
        if (category.name_el.trim().length == 0 || category.name_en.trim().length == 0) {
            app_alert.show('error', "Πληκτρολογήστε το όνομα της κατηγορίας και στις 2 γλώσσες!");
            return;
        }

        if (category.alias_parent_id > 0 && (category.alias_parent_id == category.id || category.alias_parent_id == category.parent_id)) {
            app_alert.show('error', "Η 2η κατηγορία που θα εμφανίζεται δεν είναι έγκυρη!");
            return;
        }

        const [err, res] = await categorySave(category);

        if (err) {
            alert('error ' + err);
            return;
        }

        category = res.category;
        category.children = [];

        success.show("Η κατηγορία ενημερώθηκε.");
        closeCallback(category);
    }

    const onCancel = () => {
        closeCallback();
    }
</script>

<div class="overlay">
    <div class="edit-panel" style="max-width: 500px;">
        <div class="edit-panel-heading">
            Νέα κατηγορία
        </div>
        <div class="edit-panel-body">
            <div class="form-group">
                    <label>Μαμά</label>
                    <CategoryAutoComplete bind:categoryId="{ category.parent_id }"/>
                </div>
            <hr style="margin-top: none">
            <div class="form-group">
                <label>Όνομα</label>
                <input type="text" class="form-control" id="cat-name-el"
                       bind:value="{ category.name_el }" on:focusout={onNameFocusOut}>
            </div>
            <div class="form-group">
                <label>Name</label>
                <input type="text" class="form-control" id="cat-name-en"
                       bind:value="{ category.name_en }" on:focusout={onNameFocusOut}>
            </div>
            <div class="form-group">
                <label>Link</label>
                <input type="text" class="form-control" id="cat-slug" bind:value="{ category.slug }">
            </div>
            {#if category.children.length === 0}
                <div class="form-group">
                    <label>Εμφάνιση επίσης στην κατηγορία</label>
                    <CategoryAutoComplete bind:categoryId="{ category.alias_parent_id }"/>
                </div>
            {/if}
            <div class="text-right">
                <button class="btn btn-primary btn-md" on:click="{ onSave }">Ενημέρωση</button>
                <button class="btn btn-default btn-md" on:click="{ onCancel }">Ακύρωση</button>
            </div>
        </div>
    </div>

</div>

<style>
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
    }

    .overlay .edit-panel {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>